import {gql} from 'apollo-angular';
import {StatusFragment} from "./fragments/Status";

export const GET_SCHOOL_CLASS_GAME_STATE = gql`
  query GetSchoolClassGameState($classCode: String!) {
    schoolClassGameState(classCode: $classCode) {
      status {
        ...statusFields
      }
      viewCount {
        jobs
        profiles
      }
    }
  }
  ${StatusFragment}
`;
